import { useEffect, useState } from 'react';

import Form from 'react-bootstrap/Form';

import { CloseIcon } from '../sidebars/sidebarElements/SidebarTemplate';

import { useProject } from '@contexts/Project.context';
import { useProjectMode } from '@contexts/ProjectMode.context';
import { useCollectionStore } from '@stores/useCollectionStore';
import { PROJECT_VIEW_MODE } from '@utils/constants';
import { Container, OuterContainer, StyledCheckbox, StyledHeader } from './SliderTool';

const NO_DETECTIONS = {
	id: 999,
	label: 'no detections',
	selected: true,
};

// What a checkbox stands for: a collection object's node uuid, otherwise the
// label (model classes and "no detections").
const optionValue = option => option.value ?? option.label;

const FilterSingleImage = ({ tools, setTools }) => {
	const { singleImageFeatures, pickedModelClasses, dispatch } = useProject();
	const collectionObjects = useCollectionStore(s => s.objects);
	const projectViewMode = useProjectMode();

	const [filterOptions, setFilterOptions] = useState([]);

	// The field an image's class is identified by. Collection object names are
	// not unique, so collection images match on the node uuid; model images
	// keep matching on the class name.
	const classKey =
		projectViewMode === PROJECT_VIEW_MODE.COLLECTION
			? classModel => classModel.id
			: classModel => classModel.name;

	const closeFilter = () => setTools(tools.map(tool => ({ ...tool, isActive: false })));

	const filterSingleImageFeatures = event => {
		const filterOptionClicked = event.target.value;

		const filterOptionsChanged = filterOptions.map(option => {
			optionValue(option) === filterOptionClicked && (option.selected = !option.selected);
			return option;
		});

		setFilterOptions(filterOptionsChanged);

		const valuesToShow = filterOptionsChanged
			.filter(option => option.selected)
			.map(optionValue);

		const newFilteredImages = singleImageFeatures.filter(feature => {
			if (!feature.get('detections')) {
				return valuesToShow.includes(NO_DETECTIONS.label) ? true : false;
			}

			return feature
				.get('detections')
				?.classes.some(classModel => valuesToShow.includes(classKey(classModel)));
		});
		dispatch({
			type: 'setFilteredImages',
			payload: newFilteredImages,
		});
	};

	// model mode: populate filter options from model classes
	useEffect(() => {
		if (projectViewMode !== PROJECT_VIEW_MODE.MODEL) return;
		if (pickedModelClasses?.length > 0) {
			let modelClasses = [];
			pickedModelClasses?.forEach(model => {
				model.selected = true;
				modelClasses = [...modelClasses, model];
			});
			modelClasses = [...modelClasses, NO_DETECTIONS];
			setFilterOptions(modelClasses);
		}
	}, [pickedModelClasses]);

	// collection mode: populate filter options from collection objects
	useEffect(() => {
		if (projectViewMode !== PROJECT_VIEW_MODE.COLLECTION) return;
		if (collectionObjects?.length > 0) {
			const options = collectionObjects.map(obj => ({
				id: obj.key,
				value: obj.key,
				label: obj.label,
				selected: true,
			}));
			setFilterOptions([...options, NO_DETECTIONS]);
		} else {
			setFilterOptions([]);
		}
	}, [collectionObjects]);

	if (!tools.filter(tool => tool.name === 'filtering')[0]?.isActive) {
		return null;
	}

	return (
		<OuterContainer>
			<Container>
				<StyledHeader>
					<h2>Filter Images</h2>
					<CloseIcon onClick={closeFilter} role="button" />
				</StyledHeader>
				<Form>
					{filterOptions?.map((modelClass, index) => (
						<StyledCheckbox
							key={modelClass.id}
							defaultChecked={modelClass.selected}
							label={modelClass.label}
							value={optionValue(modelClass)}
							onChange={filterSingleImageFeatures}
							id={`filter-type-${index}`}
						/>
					))}
				</Form>
			</Container>
		</OuterContainer>
	);
};

export default FilterSingleImage;
